<script>
    const selectProps = {
        dense: true,
        hideDetails: true
    };

    const textFieldProps = {
      dense: true,
      hideDetails: true
    };

    const textFieldLikeProps = {
      ...textFieldProps,
      color: 'inherit'
    };

    const additionalProps =  {
        'v-text-field': textFieldProps,
        'text-field-like': textFieldLikeProps,
        'hds-id-field': textFieldLikeProps,
        'local-id-field': textFieldLikeProps,
        'owner-field': textFieldLikeProps,
        'dictionary-name-field': textFieldLikeProps,
        'v-select': selectProps,
        'model-select': selectProps,
        'process-component-model-select': selectProps,
        'v-textarea': {
            dense: true,
            hideDetails: true,
            autoGrow: true,
            rows: "1"
        },
    };

    export default {
        name: "TableInline",
        render(h) {
            const inputVNode = Array.isArray(this.$slots.default) && this.$slots.default[0];
            if(!inputVNode) {
              return null;
            }
            const compOptions = inputVNode.componentOptions;
            Object.assign(
                compOptions.propsData,
                additionalProps[compOptions.tag]);
            return inputVNode;
        },
        mounted() {
            const td = this.$el.closest && this.$el.closest('td');
            if(td) {
                td.setAttribute(this.$options._scopeId, '');
                td.addEventListener('click', this.handleCellClick);
            }
        },
        beforeDestroy() {
            const td = this.$el.closest && this.$el.closest('td');
            if(td) {
                td.removeEventListener('click', this.handleCellClick);
            }
        },
        methods: {
            handleCellClick(e) {
                const input = this.$children[0];
                if(typeof input.focus === 'function') {
                    input.focus();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
  // テーブルの中の v-input
  ::v-deep > .cell > .v-input {
    font-size: 14px;

    .v-input__slot {
      background-color: transparent !important;
    }

    &.v-textarea {
      padding-top: 5px;
      margin-top: 0;

      textarea {
        padding: 0 12px;
        line-height: 20px;
      }
    }

    &.v-text-field {
      padding-top: 0;
      margin-top: 0;
    }

    &.v-text-field.v-input--dense:not(.v-text-field--outlined) input {
      padding: 4px 12px 2px;
    }

    &.v-select {
      &:not(.v-text-field--outlined) .v-select__selections {
        padding-left: 12px;
      }

      // v-select の時は input を使用してないので邪魔
      // v-autocomplete の時は使用しているので別
      &:not(.v-autocomplete) input {
        position: absolute;
        height: 1px;
        width: 1px;
      }
    }

    //&:not(.v-input--is-readonly).v-input--is-focused {
    //    box-shadow: inset 0 0 3px 2px rgba(25, 117, 210, 0.5);
    //    border-radius: 0;
    //}
  }
</style>
